import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Modal = styled(ModalComponent)`
  .new-file-box {
    display: flex;
    justify-content: end;
    button {
      display: flex;
      b {
        font-size: 16px;
      }
    }
  }
  .icon {
    font-size: 8rem;
    color: #707070;
  }

  .modal-content {
    border: none;
    background: #ffffff;
    border-radius: 10px;

    .modal-header {
      margin: 0px 2rem;
      margin-top: 2%;
      padding: 0px 4.5%;
    }

    h4 {
      font-weight: bold;
      font-size: 25px;
      line-height: 20px;
      color: #414141;
      //margin-left: 2rem;
      margin-top: 20px;
      line-height: 2rem;
    }

    label {
      font-weight: 500;
      color: #414141;
    }

    .input {
      border: 1px solid #d9d9d9;
      border-radius: 10px;

      input {
        font-weight: 500;
        color: #605e5e;
      }
    }

    .close {
      font-size: 24px;
      border: none;
      position: absolute;
      right: 40px;
      font-size: 30px;

      .sr-only {
        display: none;
      }
    }

    .box-footer {
      display: flex;
      justify-content: center;
    }

    .buttons-group {
      display: flex;
      button {
        width: 150px;
        height: 50px;
        border-radius: 30px;
        border: 2px solid transparent;
        margin-bottom: 15px;

        @media (max-width: 425px) {
          width: 300px;
        }

        @media (max-width: 375px) {
          width: 250px;
        }
      }

      button[type='button'] {
        color: #ffff;
        font-weight: 500;
        border-color: #f91818;
        background: #f91818;
      }
      button[type='submit'] {
        color: #ffff;
        font-weight: 500;
        border-color: #d9d9d9;
        background: #01cc9d;
      }
    }
  }
`;
